import React, { useCallback, useState } from 'react';
import EditorGalleryEdit from '@wix/da-ds/pkg/Icons/24x24/EditorGalleryEdit';
import GiphyPopup from '../../../../components/lego/GiphyPopup';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Edit = ({ editor })=>{
    const { t } = useTranslation('editor');
    const [showGiphyPopup, setShowGiphyPopup] = useState(false);
    const hideGiphyPopup = useCallback(()=>{
        setShowGiphyPopup(false);
    }, [
        setShowGiphyPopup
    ]);
    const onSelect = useCallback((gif)=>{
        var _gif_originalMp4;
        editor.chain().focus().daGifReplace({
            width: gif.width,
            height: gif.height,
            url: (_gif_originalMp4 = gif.originalMp4) !== null && _gif_originalMp4 !== void 0 ? _gif_originalMp4 : gif.originalUrl
        }).run();
    }, [
        editor
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showGiphyPopup && /*#__PURE__*/ React.createElement(GiphyPopup, {
        onClose: hideGiphyPopup,
        onSelect: onSelect
    }), /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:gif:edit",
        icon: EditorGalleryEdit,
        onClick: ()=>setShowGiphyPopup(true),
        tooltipText: t('ext.gif.button.edit'),
        "aria-label": t('ext.gif.button.edit')
    }));
};
Edit.displayName = 'Edit';
export default Edit;

//# sourceMappingURL=Edit.js.map